import { BooleanParameter } from '@drivingdoc/shared-types/reports';
import Checkbox from '@mui/material/Checkbox';
import FormControlLabel from '@mui/material/FormControlLabel';
import Grid from '@mui/material/Grid';
import { Controller, useFormContext } from 'react-hook-form';

interface BooleanParameterFieldProps {
  parameter: BooleanParameter;
}

export default function BooleanParameterField({ parameter }: BooleanParameterFieldProps) {
  const { control } = useFormContext();

  return (
    <Grid size={12}>
      <Controller
        name={parameter.name}
        control={control}
        defaultValue={parameter.config?.defaultValue ?? false}
        render={({ field }) => (
          <FormControlLabel
            control={
              <Checkbox checked={field.value as boolean} onChange={(e) => field.onChange(e.target.checked)} />
            }
            label={parameter.label}
          />
        )}
      />
    </Grid>
  );
}
